// extracted by mini-css-extract-plugin
export default {"ItemList":"ItemList_ItemList__rXVdE"};